var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170 42.649",
    fill: "#050504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "clientti-logo-circle-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af5cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8943f7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clientti-logo-rect-shadow"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 19.996,
    height: 19.996,
    transform: "translate(0 14.139) rotate(-45)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "clientti-logo-rect-gradient",
    x1: -0.207,
    y1: 0.5,
    x2: 1.207,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2e204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2b604"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "clientti-logo-rect-filter",
    x: -7,
    y: -7,
    width: 46.278,
    height: 46.278,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#050504",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-45 -69)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.338 75.387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.3,180.9a.566.566,0,0,1-.566-.566v-5.264a3.063,3.063,0,0,0-3.059-3.059h-11.9a.566.566,0,0,1,0-1.133h11.9a4.2,4.2,0,0,1,4.191,4.191v5.264A.566.566,0,0,1,208.3,180.9Z",
    transform: "translate(-192.21 -170.88)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.27,209.01l1.922,1.922,1.92-1.922v1.631l-1.92,1.92-1.922-1.92Z",
    transform: "translate(-253.099 -201.811)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.165 90.004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.822,266.392h-9.946a.566.566,0,0,1-.566-.566v-13.1a.566.566,0,0,1,1.133,0v12.532h9.379a.566.566,0,1,1,0,1.133Z",
    transform: "translate(-122.956 -251.431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.98,251.851l-1.92-1.922-1.92,1.922v-1.629l1.92-1.922,1.92,1.922Z",
    transform: "translate(-117.14 -248.3)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.104 83.303)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.173,
    cy: 14.173,
    r: 14.173,
    fill: "url(#clientti-logo-circle-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.392 96.068)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.408,
    cy: 1.408,
    r: 1.408,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.408,
    cy: 1.408,
    r: 1.408,
    transform: "translate(5.511 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.408,
    cy: 1.408,
    r: 1.408,
    transform: "translate(11.022 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45 69)",
    clipPath: "url(#clientti-logo-rect-shadow)",
    filter: "url(#clientti-logo-rect-filter)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.996,
    height: 19.996,
    transform: "translate(0 14.14) rotate(-45)",
    fill: "url(#clientti-logo-rect-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.691 76.203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.308,221.837a8.93,8.93,0,0,1,3.463-3.57A10.023,10.023,0,0,1,399.84,217a9.751,9.751,0,0,1,6.087,1.839,8.941,8.941,0,0,1,3.23,5.158h-5.39a3.926,3.926,0,0,0-1.446-2.016,4.2,4.2,0,0,0-2.517-.731,4.122,4.122,0,0,0-3.391,1.552,6.875,6.875,0,0,0-1.25,4.408,6.755,6.755,0,0,0,1.25,4.373,4.122,4.122,0,0,0,3.391,1.552,3.792,3.792,0,0,0,3.963-2.713h5.39a9.136,9.136,0,0,1-3.247,5.105,9.574,9.574,0,0,1-6.068,1.892,10.028,10.028,0,0,1-5.069-1.267,8.918,8.918,0,0,1-3.463-3.57,12.167,12.167,0,0,1,0-10.743Z",
    transform: "translate(-390.06 -209.108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.947,183.53v26.736h-5V183.53Z",
    transform: "translate(-484.07 -181.957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.824,180.275a2.99,2.99,0,0,1,0-4.225,3.262,3.262,0,0,1,4.391,0,2.99,2.99,0,0,1,0,4.225,3.268,3.268,0,0,1-4.391,0Zm4.658,3.232v20h-5v-20Z",
    transform: "translate(-520.574 -175.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.344,228.7H599.887a4.917,4.917,0,0,0,1.5,3.355,4.617,4.617,0,0,0,3.247,1.214,4.081,4.081,0,0,0,3.963-2.392h5.39a9,9,0,0,1-3.283,4.694,9.59,9.59,0,0,1-5.96,1.839,10.319,10.319,0,0,1-5.122-1.267,8.917,8.917,0,0,1-3.534-3.587,10.981,10.981,0,0,1-1.267-5.354,11.25,11.25,0,0,1,1.25-5.39,8.73,8.73,0,0,1,3.5-3.57,10.482,10.482,0,0,1,5.175-1.25,10.216,10.216,0,0,1,5.05,1.214,8.553,8.553,0,0,1,3.463,3.444,10.421,10.421,0,0,1,1.231,5.122,11.66,11.66,0,0,1-.143,1.928Zm-5.033-3.355a3.96,3.96,0,0,0-1.391-3.087A4.937,4.937,0,0,0,604.6,221.1a4.523,4.523,0,0,0-3.123,1.125,4.944,4.944,0,0,0-1.554,3.123h9.387Z",
    transform: "translate(-556.162 -209.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.2,219.42a8.542,8.542,0,0,1,2.177,6.228v11.923h-5V226.326A5.129,5.129,0,0,0,726.2,222.7a4.175,4.175,0,0,0-3.213-1.267,4.311,4.311,0,0,0-3.266,1.267,5.08,5.08,0,0,0-1.2,3.623v11.245h-5v-20.1h5v2.464a6.9,6.9,0,0,1,2.552-2.016,7.9,7.9,0,0,1,3.41-.733,7.621,7.621,0,0,1,5.711,2.232Z",
    transform: "translate(-652.46 -209.262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.856,203.494v-4.1H845.43V194.5H840.4v4.89h-7.924V194.5H827.44v4.89h.009v4.1h-.009v9.531q0,6.14,6.317,6.14H836.9v-4.212h-2.32a2.369,2.369,0,0,1-1.624-.446,1.891,1.891,0,0,1-.481-1.446v-9.566H840.4v9.531q0,6.14,6.317,6.14h3.142v-4.212h-2.32a2.369,2.369,0,0,1-1.624-.446,1.891,1.891,0,0,1-.481-1.446v-9.566h4.425Z",
    transform: "translate(-744.864 -190.856)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.824,180.275a2.99,2.99,0,0,1,0-4.225,3.262,3.262,0,0,1,4.391,0,2.99,2.99,0,0,1,0,4.225,3.268,3.268,0,0,1-4.391,0Zm4.658,3.232v20h-5v-20Z",
    transform: "translate(-443.774 -175.2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientti);
export default __webpack_public_path__ + "static/media/clientti.abd88e4fc4773ea0629ad96e73f172fc.svg";
export { ForwardRef as ReactComponent };